import React, {Fragment, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Chip_input, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import axios from 'axios';

export default function CallManager_setup_popup(props){


  function onSubmit(params){
    axios.put('/api/callManagerSetup', params).then(()=>{
      window.location.href='/setup';
    })
  }

  let queues=[];
  if(props.queues!=undefined){for(let key in props.queues){queues.push(props.queues[key]);}}

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{...props.workspace.call_manager_setup, call_manager_on:props.workspace.call_manager, connect_rate_limit:Math.round(((props.workspace.call_manager_setup==undefined)?(100*3.46)/15:(100*props.workspace.call_manager_setup.connect_rate_limit)/15)*100)/100}}
      mutators={{
        ...arrayMutators
      }}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} always_open accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose()}} title='call_manager_setup_title' content={
          <div style={{width:'95vw', maxWidth:'600px', marginTop:'20px', marginBottom:'20px'}}>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'20px'}}><Field name='call_manager_on'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Call manager on"/>}/>}</Field></div>
          <div style={{width:'calc(100% - 40px)', maxWidth:'300px', marginLeft:'10px', marginBottom:'20px'}}><Text  type='number' color='transparent' title='Line connect index (LCI) limit' name='connect_rate_limit'/></div>
          <Typography>
            <Typography color='primary' style={{fontWeight:'bold'}}><Grid container><Grid item xs={3} style={{paddingLeft:'20px'}}>Type</Grid><Grid item xs={4} style={{paddingLeft:'20px'}}>Priority</Grid><Grid item xs={4} style={{paddingLeft:'20px'}}>Queue</Grid></Grid></Typography>
            <Grid container style={{marginTop:'10px'}}><Grid item xs={3}><span style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>New</span></Grid><Grid item xs={4}><Select color='transparent' name='priority_new' select_data={[{id:0, name:'High'}, {id:1, name:'Medium'}, {id:3, name:'Low'}]}/></Grid><Grid item xs={4}><Select size='small' color='transparent' name='task_queue_id_new' select_data={queues}/></Grid></Grid>
            <Grid container style={{marginTop:'10px'}}><Grid item xs={3}><span style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>Working</span></Grid><Grid item xs={4}><Select size='small' color='transparent' name='priority_working' select_data={[{id:0, name:'High'}, {id:1, name:'Medium'}, {id:3, name:'Low'}]}/></Grid><Grid item xs={4}><Select color='transparent' name='task_queue_id_working' select_data={queues}/></Grid></Grid>
            <Grid container style={{marginTop:'10px'}}><Grid item xs={3}><span style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>Priority</span></Grid><Grid item xs={4}><Select size='small' color='transparent' name='priority_priority' select_data={[{id:0, name:'High'}, {id:1, name:'Medium'}, {id:3, name:'Low'}]}/></Grid><Grid item xs={4}><Select color='transparent' name='task_queue_id_priority' select_data={queues}/></Grid></Grid>
            <Grid container style={{marginTop:'10px'}}><Grid item xs={3}><span style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>Scheduled</span></Grid><Grid item xs={4}><Select size='small' color='transparent' name='priority_scheduled' select_data={[{id:0, name:'High'}, {id:1, name:'Medium'}, {id:3, name:'Low'}]}/></Grid><Grid item xs={4}><Select color='transparent' name='task_queue_id_scheduled' select_data={queues}/></Grid></Grid>
          </Typography>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}
